import ServiceReports from '../../../../../services/ServiceReports';

class Service extends ServiceReports {
  constructor() {
    super('/authentication');
  }
}

export default new Service();
